// import { useEffect } from 'react';
import {
  Link,
  LinkButton,
  SparkIcon
  // SparkLendIcon,
  // SparkLiquidityLayerIcon,
  // SparkSavingsIcon
} from '@/components';
import { currentSeason, sparkUrl } from '@/utils';
import {
  ArrowUpRightBoxIcon,
  // Box,
  // BoxProps,
  Card,
  // CollapsableSidebar,
  // CrossIcon,
  // CryptoIcon,
  Flex,
  // MenuIcon,
  // useIsMobile,
  // useToggle,
  Heading,
  // FlexProps,
  LinkWrapper
} from '@blockanalitica/ui';
// import { NavLink, useLocation } from 'react-router';
import styled from 'styled-components';

export interface HeaderLinkProps {
  $hoverBorderColor: string;
}

const LogoWrapper = styled(Card)`
  & svg {
    filter: brightness(0);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover svg {
    filter: brightness(100%);
  }
`;

// const HeaderLink = styled(LinkWrapper)<HeaderLinkProps>`
//   display: flex;
//   align-items: center;
//   transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

//   ${(props) => css`
//     color: ${props.theme.colors.text};
//     gap: ${props.theme.space['2xs']};
//     padding: ${props.theme.space['2xs']} ${props.theme.space['s']};
//     border-radius: ${props.theme.space['2xs']};
//     border: solid 1px ${props.theme.colors.border};

//     &:hover,
//     &.active {
//       border-color: ${props.theme.colors[props.$hoverBorderColor]};
//       color: ${props.theme.colors.text};
//     }
//   `}
// `;

// const MobileHeaderLink = styled(LinkWrapper)<HeaderLinkProps>`
//   display: flex;
//   align-self: stretch;
//   align-items: center;
//   transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);

//   ${(props) => css`
//     color: ${props.theme.colors.text};
//     gap: ${props.theme.space['2xs']};
//     font-size: ${props.theme.sizes['2']};

//     &:hover,
//     &.active {
//     }
//   `}
// `;

// const CloseButton = styled(Box)<BoxProps>`
//   cursor: pointer;
//   &:hover {
//     color: ${(props) => props.theme.colors.linkHover};
//   }
// `;

// const MenuButton = styled(Flex)<FlexProps>`
//   cursor: pointer;

//   &:hover {
//     color: ${(props) => props.theme.colors.linkHover};
//   }
// `;

// const AlphaBackgroundLayer = styled.div`
//   display: block;
//   position: fixed;
//   inset: 0;
//   background-color: ${(props) => props.theme.colors.black65};
//   z-index: 49;
//   backdrop-filter: blur(12px);
//   -webkit-backdrop-filter: blur(12px);
// `;

export default function Header() {
  // const [sidebarOpen, toggleSidebar] = useToggle();
  // const isMobile = useIsMobile();

  // const location = useLocation();

  // useEffect(() => {
  //   toggleSidebar(false);
  // }, [location.pathname, toggleSidebar]);

  return (
    <>
      <Flex gap="xs" justifyContent="space-between">
        <Flex gap="xs" alignItems="center">
          <LinkWrapper
            // @ts-ignore
            as={Link}
            to="/"
            display="flex">
            <LogoWrapper
              flex="0"
              padding="xs"
              alignItems="center"
              justifyContent="center">
              <SparkIcon size="5" />
            </LogoWrapper>
          </LinkWrapper>

          <Heading fontSize="5">
            Spark Points | Season {currentSeason()}
          </Heading>
        </Flex>
        <Flex alignItems="center">
          <LinkButton
            variant="fancy"
            as="a"
            gap="2xs"
            // @ts-ignore
            href={sparkUrl('https://app.spark.fi/points')}
            rel="noreferrer"
            target="_blank">
            Spark Points
            <ArrowUpRightBoxIcon size="-1" />
          </LinkButton>
        </Flex>

        {/*<Card
          flexDirection="row"
          alignItems="center"
          gap="xs"
          padding="xs"
          flex={isMobile ? '0' : '1'}>
          {isMobile ? (
            <>
              <CollapsableSidebar
                sidebarOpen={sidebarOpen}
                toggleSidebar={toggleSidebar}
                alignItems="flex-start"
                gap="xl">
                <Flex
                  justifyContent="space-between"
                  width="100%"
                  paddingTop="s">
                  <SparkIcon size="5" />
                  <CloseButton
                    alignSelf="center"
                    onClick={() => toggleSidebar(false)}>
                    <CrossIcon size="3" />
                  </CloseButton>
                </Flex>
                <Flex flexDirection="column" width="100%" gap="m">
                  <MobileHeaderLink
                    as={NavLink}
                    to="/spark-liquidity-layer"
                    $hoverBorderColor="sparkLiquidityLayerColor">
                    <SparkLiquidityLayerIcon size="1" /> Spark Liquidity Layer
                  </MobileHeaderLink>
                  <MobileHeaderLink
                    as={NavLink}
                    to="/savings"
                    $hoverBorderColor="sparkSavingsColor">
                    <SparkSavingsIcon size="1" /> Savings
                  </MobileHeaderLink>
                  <MobileHeaderLink
                    as={NavLink}
                    to="/spk"
                    $hoverBorderColor="sparkSpkColor">
                    <CryptoIcon
                      name="SPK"
                      address="0x00000000000000000000000000000000000spark"
                      size="1"
                    />
                    SPK
                  </MobileHeaderLink>
                  <MobileHeaderLink
                    as={NavLink}
                    to="/sparklend"
                    $hoverBorderColor="sparkLendColor">
                    <SparkLendIcon size="1" /> SparkLend
                  </MobileHeaderLink>
                </Flex>
              </CollapsableSidebar>

              <MenuButton
                onClick={() => toggleSidebar()}
                padding="unset"
                paddingLeft="2xs"
                paddingRight="2xs">
                <MenuIcon size="3" />
              </MenuButton>
            </>
          ) : (
            <>
              <HeaderLink
                as={NavLink}
                to="/spark-liquidity-layer"
                $hoverBorderColor="sparkLiquidityLayerColor">
                <SparkLiquidityLayerIcon size="1" /> Spark Liquidity Layer
              </HeaderLink>
              <HeaderLink
                as={NavLink}
                to="/savings"
                $hoverBorderColor="sparkSavingsColor">
                <SparkSavingsIcon size="1" /> Savings
              </HeaderLink>
              <HeaderLink
                as={NavLink}
                to="/spk"
                $hoverBorderColor="sparkSpkColor">
                <CryptoIcon
                  name="SPK"
                  address="0x00000000000000000000000000000000000spark"
                  size="1"
                />
                SPK
              </HeaderLink>
              <HeaderLink
                as={NavLink}
                to="/sparklend"
                $hoverBorderColor="sparkLendColor">
                <SparkLendIcon size="1" /> SparkLend
              </HeaderLink>
            </>
          )}
        </Card>*/}
      </Flex>
      {/*{sidebarOpen ? (
        <AlphaBackgroundLayer onClick={() => toggleSidebar()} />
      ) : null}*/}
    </>
  );
}
